"use strict";

var _slicedToArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ModuleCode =
/*#__PURE__*/
function () {
  function ModuleCode(code) {
    _classCallCheck(this, ModuleCode);

    this.m_File = utility_1.ToFile(code);
  }

  _createClass(ModuleCode, [{
    key: "ToDraft",
    value: function ToDraft() {
      this.m_File = utility_1.ToFile(utility_1.ToString(this.m_File));
      var draft = [];
      this.Traverse({
        Program: function Program(path) {
          this._module.m_Path = path;
        },
        ExpressionStatement: function ExpressionStatement(path) {
          var expression = path.get("expression");

          if (expression.isStringLiteral()) {
            var literal = expression.node.value.trim();

            if (literal.startsWith("use") && path.parentPath.isBlockStatement()) {
              draft.unshift(new inline_context_1.InlineContext(path.parentPath));
            }
          }
        }
      }, {
        _module: this
      });
      this.m_Path.get("body").forEach(function (path) {
        if (path.isEmptyStatement()) {
          path.remove();
        } else if (IsExportClassCode(path)) {
          draft.push(new export_class_1.ExportClassCode(path));
        } else if (IsMethodCode(path)) {
          draft.push(new method_1.MethodCode(path));
        } else if (IsLocalContext(path)) {
          draft.push(new local_context_1.LocalContext(path.scope.parent.getBinding(path.node.id.name)));
        }
      });
      return draft;
    }
  }, {
    key: "Traverse",
    value: function Traverse(visitor) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.m_File = utility_1.ToFile(utility_1.ToString(this.m_File));
      traverse_1.default(this.m_File, visitor, null, state);
    }
  }]);

  return ModuleCode;
}();

exports.ModuleCode = ModuleCode;

function IsExportClassCode(path) {
  if (!path.isExportNamedDeclaration()) {
    return false;
  }

  var declaration = path.get("declaration");
  return declaration.isClassDeclaration();
}

exports.IsExportClassCode = IsExportClassCode;

function IsMethodCode(path) {
  if (!path.isExpressionStatement()) {
    return false;
  }

  var expression = path.get("expression");

  if (!expression.isBinaryExpression()) {
    return false;
  }

  var left = expression.get("left");
  var right = expression.get("right");
  return left.isJSXElement() && right.isFunctionExpression();
}

exports.IsMethodCode = IsMethodCode;

function IsLocalContext(path) {
  if (!path.isFunctionDeclaration()) {
    return false;
  }

  var _path$node$body$direc = _slicedToArray(path.node.body.directives, 1),
      directive = _path$node$body$direc[0];

  var is_local_context = path.scope.parent.getBinding(path.node.id.name).referencePaths.some(function (path) {
    var _a, _b, _c, _d, _e;

    var used_as_jsx = (_b = (_a = path.parentPath) === null || _a === void 0 ? void 0 : _a.parentPath) === null || _b === void 0 ? void 0 : _b.isJSXElement();
    var used_as_statement = (_e = (_d = (_c = path.parentPath) === null || _c === void 0 ? void 0 : _c.parentPath) === null || _d === void 0 ? void 0 : _d.parentPath) === null || _e === void 0 ? void 0 : _e.isExpressionStatement();
    var has_context = Boolean(directive);
    return used_as_jsx && (has_context || used_as_statement);
  });
  return is_local_context;
}

exports.IsLocalContext = IsLocalContext;

var export_class_1 = require("./export-class");

var method_1 = require("./method");

var local_context_1 = require("./local-context");

var utility_1 = require("../common/utility");

var traverse_1 = require("@babel/traverse");

var inline_context_1 = require("./inline-context");